"use client";

import { FC, useState } from "react";
import { getDataAutomationGroup, getDataLinkAttributes } from "@/helpers";
import { Search } from "@/icons";
import { GlobalNavigationProps } from "../GlobalNavigation";

export type SearchBarProps = {
  onSubmit: (searchValue: string) => void;
} & Pick<GlobalNavigationProps["superHeader"], "search">;

const SearchBar: FC<SearchBarProps> = ({
  search: {
    submitButtonDLD,
    submitButtonDLT,
    submitButtonLabel,
    inputLabel,
    inputPlaceholder,
  },
  onSubmit,
}) => {
  const [search, setSearch] = useState<string>("");

  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        onSubmit(search);
      }}
      className="text-swdc-black-600 relative mx-auto flex max-w-full"
      autoComplete="off"
    >
      <button
        className="text-swdc-black-600 absolute top-1/2 -translate-y-1/2 pl-3.5 text-base"
        type="submit"
        {...getDataLinkAttributes({
          dld: submitButtonDLD,
          dlt: submitButtonDLT,
        })}
      >
        <span className="sr-only">{submitButtonLabel}</span>
        <Search type="icon-28" width={28} height={28} />
      </button>
      <label className="sr-only" htmlFor="search-input">
        {inputLabel}
      </label>
      <input
        className="border-swdc-black-600 text-link-m placeholder:text-swdc-gray-200 grow rounded-4xl border py-1.75 pr-1 pl-11 leading-5 focus:border-black focus:outline focus:outline-white"
        type="text"
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        id="search-input"
        placeholder={inputPlaceholder}
        {...getDataAutomationGroup("input-field")}
      />
    </form>
  );
};

export default SearchBar;
